import { format as datefnsFormat } from 'date-fns';

/**
 * Return the formatted date string in the given format. The result may vary by locale.
 * see https://date-fns.org/v2.21.1/docs/format for full formatting options.
 */
export type DateFormat =
    | 'PP'
    | 'PP H:mm:ss'
    | 'PPpp'
    | 'LLLL y'
    | 'LLLL do'
    | 'dd-MM-yyyy'
    | 'yyyy-MM-dd'
    | 'yyyy-MM-dd H:mm:ss';

const formatDate = (date: Date, format: DateFormat) => datefnsFormat(date, format);

export default formatDate;
